import React, { FC } from 'react';
import { CreateSurveyCardsNames, CreateSurveyTypeNames } from '../../constans/state';
import { PageTab, PageTabsCont } from '../../styles/globals';

interface ITabGroup {
  tabs: { name: string; value: string }[];
  applyFilters: (filters: Record<string, string | null | undefined>) => void;
  defaultValue?: string;
  surveyOverviewType: string;
  selectedTab: string;
  setBlockedTab: (tab: string) => void;
  isTransitionBlocked: boolean;
}

const TabGroup: FC<ITabGroup> = ({
  tabs,
  selectedTab,
  applyFilters,
  setBlockedTab,
  surveyOverviewType,
  isTransitionBlocked,
}) => {
  const changeCard = (card: string) => {
    if (isTransitionBlocked) {
      setBlockedTab(card);
    }

    const domain =
      card === CreateSurveyCardsNames.participantsandreports
        ? CreateSurveyTypeNames.reportsSetup
        : card === CreateSurveyCardsNames.dashboard
          ? CreateSurveyTypeNames.overview
          : surveyOverviewType === 'EFFECT' && card === CreateSurveyCardsNames.contents
            ? CreateSurveyTypeNames.internal
            : null;

    const clearedFilters = {
      pageNo: null,
      sortOrder: null,
      perPage: null,
      addTeam: null,
      compare: null,
      compareSort: null,
      activeSection: null,
      surveyReport: null,
      prm: null,
      riskAnalysis: null,
      predictiveStates: null,
      search: null,
      language: null,
      reports: null,
      domain,
      card,
    };
    applyFilters(clearedFilters);
  };

  return (
    <PageTabsCont id="TabsCont" data-testid="tabsContainer" role="tablist">
      {tabs.map(tab => {
        const isActive = selectedTab === tab.value;
        return (
          <PageTab
            id="TabButton"
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            data-testid="tab"
            $isActive={isActive}
            onClick={() => changeCard(tab.value)}
          >
            {tab.name}
          </PageTab>
        );
      })}
    </PageTabsCont>
  );
};

export default TabGroup;
